import { graphql, useStaticQuery } from 'gatsby';

export type UseNavigation = {
  navigation: Queries.ContentfulNavigationBar001;
};

const useNavigation = (): UseNavigation => {
  const { allContentfulNavigationBar001 } = useStaticQuery(graphql`
    fragment ButtonProperties on ContentfulButtonProperties001 {
      icon
      theme {
        backgroundColor
        textColor
      }
    }

    query NavigationQuery {
      allContentfulNavigationBar001(
        filter: { contentfulid: { eq: "www-navigation-bar" } }
        limit: 1
      ) {
        nodes {
          topLevelMenuItems {
            menuDrawers {
              menuLabel
              url
              mainCta {
                label
                url
              }
              hasOnlySpotlightCards
              menuSpotlights {
                title
                description {
                  description
                }
                image {
                  mobileImage {
                    url
                  }
                  mobileImageAltText
                  desktopImage {
                    url
                  }
                  desktopImageAltText
                }
                theme {
                  backgroundColor
                }
                cta {
                  label
                  url
                }
              }
              menuDrawerGroups {
                groupLabel
                menuLinks {
                  label
                  secondaryLabel
                  url
                  isSearchable
                }
              }
              mainCta {
                label
                url
              }
              buttonProperties {
                ...ButtonProperties
              }
            }
          }
        }
      }
    }
  `);

  return {
    navigation: allContentfulNavigationBar001.nodes[0],
  };
};

export default useNavigation;
